export const CREATE_LMS_COURSE_REQUEST = '@lmsCourse/LMS_COURSE_REQUEST';
export const CREATE_LMS_COURSE_SUCCESS = '@lmsCourse/LMS_COURSE_SUCCESS';
export const CREATE_LMS_COURSE_FAILURE = '@lmsCourse/LMS_COURSE_FAILURE';
